/* External */
import { memo } from 'react';
import PropTypes from 'prop-types';
import { withFocusable } from '@noriginmedia/react-spatial-navigation';

/* Styles */
import './Modal.scss';

function Modal({
  children,
  isModalShown,
  backgroundOpacity,
}) {
  return (
    <div className={`
      dtv-html5-c-modal
      ${isModalShown ? 'dtv-html5-c-modal--active' : ''}
      ${backgroundOpacity ? 'dtv-html5-c-modal--background-opacity' : ''}
    `}
    >
      {children}
    </div>
  );
}

Modal.propTypes = {
  children: PropTypes.node.isRequired,
  isModalShown: PropTypes.bool.isRequired,
  backgroundOpacity: PropTypes.bool,
};

Modal.defaultProps = {
  backgroundOpacity: false,
};

export default memo(withFocusable()(memo(Modal)));
